"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.diffFilters = void 0;
const utils_1 = require("./utils");
const request_merger_1 = require("./request-merger");
function diffFilters(prev, next, calcRemoved) {
    const added = [];
    const removed = [];
    prev = [...prev];
    next = [...next];
    for (const n of next) {
        const px = prev.findIndex(a => (0, utils_1.flatFilterEq)(a, n));
        if (px !== -1) {
            prev.splice(px, 1);
        }
        else {
            added.push(n);
        }
    }
    if (calcRemoved) {
        for (const p of prev) {
            const px = next.findIndex(a => (0, utils_1.flatFilterEq)(a, p));
            if (px !== -1) {
                next.splice(px, 1);
            }
            else {
                removed.push(p);
            }
        }
    }
    const changed = added.length > 0 || removed.length > 0;
    return {
        added: changed ? (0, request_merger_1.flatMerge)(added) : [],
        removed: changed ? (0, request_merger_1.flatMerge)(removed) : [],
        changed,
    };
}
exports.diffFilters = diffFilters;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdC1zcGxpdHRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9yZXF1ZXN0LXNwbGl0dGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLG1DQUF1QztBQUV2QyxxREFBNkM7QUFFN0MsU0FBZ0IsV0FBVyxDQUFDLElBQTBCLEVBQUUsSUFBMEIsRUFBRSxXQUFxQjtJQUN2RyxNQUFNLEtBQUssR0FBRyxFQUFFLENBQUM7SUFDakIsTUFBTSxPQUFPLEdBQUcsRUFBRSxDQUFDO0lBRW5CLElBQUksR0FBRyxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUM7SUFDakIsSUFBSSxHQUFHLENBQUMsR0FBRyxJQUFJLENBQUMsQ0FBQztJQUNqQixLQUFLLE1BQU0sQ0FBQyxJQUFJLElBQUksRUFBRTtRQUNwQixNQUFNLEVBQUUsR0FBRyxJQUFJLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsSUFBQSxvQkFBWSxFQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBQ25ELElBQUksRUFBRSxLQUFLLENBQUMsQ0FBQyxFQUFFO1lBQ2IsSUFBSSxDQUFDLE1BQU0sQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDLENBQUM7U0FDcEI7YUFBTTtZQUNMLEtBQUssQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUM7U0FDZjtLQUNGO0lBQ0QsSUFBSSxXQUFXLEVBQUU7UUFDZixLQUFLLE1BQU0sQ0FBQyxJQUFJLElBQUksRUFBRTtZQUNwQixNQUFNLEVBQUUsR0FBRyxJQUFJLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQUMsSUFBQSxvQkFBWSxFQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ25ELElBQUksRUFBRSxLQUFLLENBQUMsQ0FBQyxFQUFFO2dCQUNiLElBQUksQ0FBQyxNQUFNLENBQUMsRUFBRSxFQUFFLENBQUMsQ0FBQyxDQUFDO2FBQ3BCO2lCQUFNO2dCQUNMLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUM7YUFDakI7U0FDRjtLQUNGO0lBQ0QsTUFBTSxPQUFPLEdBQUcsS0FBSyxDQUFDLE1BQU0sR0FBRyxDQUFDLElBQUksT0FBTyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUM7SUFDdkQsT0FBTztRQUNMLEtBQUssRUFBRSxPQUFPLENBQUMsQ0FBQyxDQUFDLElBQUEsMEJBQVMsRUFBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLENBQUMsRUFBRTtRQUN0QyxPQUFPLEVBQUUsT0FBTyxDQUFDLENBQUMsQ0FBQyxJQUFBLDBCQUFTLEVBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQUU7UUFDMUMsT0FBTztLQUNSLENBQUM7QUFDSixDQUFDO0FBOUJELGtDQThCQyJ9